import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import LocaleContext, {Locale} from 'contexts/LocaleContext';

export interface WithLocaleProps {
    locale: Locale;
}

export default function withLocale<T extends WithLocaleProps>(
    WrappedComponent: React.ComponentType<T>,
) {
    class WithLocale extends React.Component<Omit<T, keyof WithLocaleProps>> {
        static displayName = `withLocale(${
            WrappedComponent.displayName || WrappedComponent.name || 'Component'
        })`;
        static contextType = LocaleContext;

        render() {
            return <WrappedComponent {...(this.props as T)} locale={this.context} />;
        }
    }

    // Copies non-react specific statics from a child component to a parent component
    hoistNonReactStatics(WithLocale, WrappedComponent);
    return WithLocale;
}
